import {
   AbstractReactFactory,
} from "@projectstorm/react-diagrams";
import CustomNodeWidget from "./CustomNodeWidget";
import { CustomNodeModel } from "./CustomNodeModel";
import React from 'react';

export class CustomNodeFactory extends AbstractReactFactory {
	constructor() {
		super("custom");
	}

	generateReactWidget(event){
		const updatedNode = Object.assign(new CustomNodeModel(), event.model)
		return <CustomNodeWidget engine={this.engine} node={updatedNode} />;
	}

	getNewInstance() {
		return new CustomNodeModel();
	}
}